import { Injectable } from '@angular/core';
import * as countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import {
  getCountries,
  getCountryCallingCode,
  getExampleNumber
} from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';

export interface Country {
  name: string;
  code: string;
  dialCode: string;
  minLength: number;
  maxLength: number;
}

@Injectable({ providedIn: 'root' })
export class CountryService {

  constructor() {
    countries.registerLocale(en);
  }

  getCountries(): Country[] {
    const countryNames = countries.getNames('en', { select: 'official' });
    return getCountries().map(code => {
      let minLength = 6;
      let maxLength = 15;
      if (code === 'ID') {
        minLength = 8;
        maxLength = 11;
      } else {
        try {
          const example = getExampleNumber(code as any, examples);
          if (example?.nationalNumber) {
            const len = example.nationalNumber.length;
            minLength = len;
            maxLength = len;
          }
        } catch {
          // safe fallback
        }
      }
      return {
        code,
        name: countryNames[code] || code,
        dialCode: '+' + getCountryCallingCode(code),
        minLength,
        maxLength
      };
    }).sort((a, b) => a.name.localeCompare(b.name));
  }
}